module.exports = __webpack_public_path__ + "static/img/icon-export.3913e143.svg";